<ng-container *ngrxLet="icapLog$ as icapLog">
    <div logFieldTitle>
        {{ globalL10nKeys.actionLabel | vtranslate }}
    </div>
    <div
        logFilter
        property="icap_log.action"
        [value]="action"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
        *ngIf="icapLog.action as action; else na"
    >
        {{ action | enumValueLabel : 'IcapAction' }}
    </div>

    <!-- ICAP Request Log grid -->
    <avi-data-grid
        *ngIf="icapLog.request_logs?.length"
        [config]="icapRequestLogsGridConfig"
        [rows]="icapLog.request_logs"
    ></avi-data-grid>
</ng-container>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>

<ng-template
    #requestActionTemplateRef
    let-row
    let-index="index"
>
    <span
        logFilter
        property="icap_log.request_logs.action"
        [value]="action"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
        *ngIf="row.action as action; else na"
    >
        {{ action | enumValueLabel : 'IcapAction' }}
    </span>
</ng-template>

<ng-template
    #reasonTemplateRef
    let-row
    let-index="index"
>
    <span
        logFilter
        property="icap_log.request_logs.opswat_log.reason"
        [value]="reason"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
        *ngIf="row.opswat_log?.reason as reason; else na"
    >
        {{ reason }}
    </span>
</ng-template>

<ng-template
    #violationsTemplateRef
    let-row
    let-index="index"
>
    <cds-icon
        status="warning"
        shape="warning-standard"
        size="sm"
    ></cds-icon>
    {{ l10nKeys.violationsLabel | vtranslate: (row.opswat_log?.violations?.length || 0) }}
</ng-template>

<ng-template
    #expandedContentTemplateRef
    let-row
>
    <div class="log-cinematic-sub-section-icap__grid-expanded-content">
        <!-- Summary -->
        <div class="log-cinematic-sub-section-icap__grid-expanded-content-section">
            <!-- left column -->
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ globalL10nKeys.summaryLabel | vtranslate }}
                </h5>

                <div logFieldTitle>{{ l10nKeys.threatIdLabel | vtranslate }}</div>
                <div
                    logFilter
                    property="icap_log.request_logs.opswat_log.threat_id"
                    [value]="threatId"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    *ngIf="row.opswat_log?.threat_id as threatId; else na"
                >
                    {{ threatId }}
                </div>

                <div logFieldTitle>{{ l10nKeys.seSourcePortLabel | vtranslate }}</div>
                <div
                    logFilter
                    property="icap_log.request_logs.source_port"
                    [value]="row.source_port"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    *ngIf="row.source_port !== undefined; else na"
                >
                    {{ row.source_port }}
                </div>

                <div logFieldTitle>
                    {{ l10nKeys.icapServerIpLabel | vtranslate }}:{{ globalL10nKeys.portLabel | vtranslate }}
                </div>
                <ng-container *ngIf="row.icap_server_ip !== undefined; else na">
                    <span
                        logFilter
                        property="icap_log.request_logs.icap_server_ip"
                        [value]="row.icap_server_ip"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.icap_server_ip }}
                    </span>
                    <ng-container *ngIf="row.icap_server_port !== undefined">
                        :<span logFilter>
                            {{ row.icap_server_port }}
                        </span>
                    </ng-container>
                </ng-container>

                <div logFieldTitle>{{ l10nKeys.icapLatencyLabel | vtranslate }}</div>
                <div
                    logFilterList
                    property="icap_log.request_logs.latency"
                    [value]="row.latency"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    *ngIf="row.latency !== undefined; else na"
                >
                    {{ row.latency }} {{ globalL10nKeys.msLabel | vtranslate }}
                </div>
            </div>

            <!-- right column -->
            <div
                *ngIf="row.opswat_log?.violations as violations"
                logCinematicSectionColumn
                [withDivider]="false"
            >
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.violationsLabel | vtranslate: violations.length }}
                </div>

                <div
                    *ngFor="let violation of violations; trackBy: trackByIndex"
                    class="log-cinematic-sub-section-icap__violation-box"
                >
                    <cds-icon
                        status="warning"
                        shape="warning-standard"
                        size="sm"
                    ></cds-icon>
                    <div class="log-cinematic-sub-section-icap__violation-info">
                        <div
                            logFieldTitle
                            [withMarginTop]="false"
                        >
                            {{ l10nKeys.fileNameLabel | vtranslate }}
                        </div>
                        <div
                            logFilter
                            property="icap_log.request_logs.opswat_log.violations.file_name"
                            [value]="fileName"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                            *ngIf="violation.file_name as fileName; else na"
                        >
                            {{ fileName }}
                        </div>

                        <div logFieldTitle>{{ l10nKeys.threatNameLabel | vtranslate }}</div>
                        <div
                            logFilter
                            property="icap_log.request_logs.opswat_log.violations.threat_name"
                            [value]="threatName"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                            *ngIf="violation.threat_name as threatName; else na"
                        >
                            {{ threatName }}
                        </div>

                        <div logFieldTitle>{{ l10nKeys.violationResolutionLabel | vtranslate }}</div>
                        <div
                            logFilter
                            property="icap_log.request_logs.opswat_log.violations.resolution"
                            [value]="resolution"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                            *ngIf="violation.resolution as resolution; else na"
                        >
                            {{ resolution | enumValueLabel : 'IcapViolationResolution' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Request / Response -->
        <div class="log-cinematic-sub-section-icap__grid-expanded-content-section">
            <!-- left column -->
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ globalL10nKeys.requestLabel | vtranslate }}
                </h5>

                <div logFieldTitle>{{ globalL10nKeys.httpMethodLabel | vtranslate }}</div>
                <div
                    *ngIf="row.http_method as httpMethod; else na"
                    logFilter
                    property="icap_log.request_logs.http_method"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    [value]="httpMethod"
                >
                    {{ httpMethod | enumValueLabel : 'HTTPMethod' }}
                </div>

                <div logFieldTitle>{{ l10nKeys.completeBodySentLabel | vtranslate }}</div>
                <div
                    logFilter
                    property="icap_log.request_logs.complete_body_sent"
                    [value]="row.complete_body_sent"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    *ngIf="row.complete_body_sent !== undefined; else na"
                >
                    {{ row.complete_body_sent }}
                </div>

                <div logFieldTitle>{{ l10nKeys.icapAbsoluteUriLabel | vtranslate }}</div>
                <div
                    logFilter
                    property="icap_log.request_logs.icap_absolute_uri"
                    [value]="row.icap_absolute_uri"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    *ngIf="row.icap_absolute_uri as uri; else na"
                >
                    {{ uri }}
                </div>

                <div logFieldTitle>{{ l10nKeys.icapMethodLabel | vtranslate }}</div>
                <div
                    logFilter
                    property="icap_log.request_logs.icap_method"
                    [value]="row.icap_method"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                    *ngIf="row.icap_method as icapMethod; else na"
                >
                    {{ icapMethod | enumValueLabel : 'ICAPMethod' }}
                </div>
            </div>

            <!-- right column -->
            <div
                logCinematicSectionColumn
                [withDivider]="false"
                class="log-cinematic-sub-section-icap__response-column"
            >
                <h5 class="log-cinematic-section__column-title log-cinematic-sub-section-icap__grid-expanded-content-response-title">
                    {{ globalL10nKeys.responseLabel | vtranslate }}
                </h5>

                <div logFieldTitle>{{ l10nKeys.httpResponseCodeLabel | vtranslate }}</div>
                <ng-container *ngIf="row.http_response_code !== undefined; else na">
                    <span
                        logFilter
                        property="icap_log.request_logs.http_response_code"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                        [value]="row.http_response_code"
                    >
                        {{ row.http_response_code }}
                    </span>
                </ng-container>

                <div logFieldTitle>{{ l10nKeys.modifiedContentLengthLabel | vtranslate }}</div>
                <ng-container *ngIf="row.modified_content_length !== undefined; else na">
                    <span
                        logFilterList
                        property="icap_log.request_logs.modified_content_length"
                        [value]="row.modified_content_length"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.modified_content_length }}
                    </span>
                </ng-container>

                <div logFieldTitle>{{ l10nKeys.icapResponseCodeLabel | vtranslate }}</div>
                <ng-container *ngIf="row.icap_response_code !== undefined; else na">
                    <span
                        logFilter
                        property="icap_log.request_logs.icap_response_code"
                        [value]="row.icap_response_code"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.icap_response_code }}
                    </span>
                </ng-container>
            </div>
        </div>

        <!-- Headers -->
        <div class="log-cinematic-sub-section-icap__grid-expanded-content-section">
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ l10nKeys.icapHeadersLabel | vtranslate }}
                </h5>
                <avi-diff-grid
                    [config]="headersDiffGridConfig"
                    [rows]="row | subLogHeadersDiffSourcePair : 'icap_headers_sent_to_server' : 'icap_headers_received_from_server' | aviDiffGridRows"
                ></avi-diff-grid>
            </div>
        </div>
    </div>
</ng-template>
